{
  "common": {
    "save": "Uložiť",
    "cancel": "Zrušiť",
    "delete": "Zmazať",
    "edit": "Upraviť",
    "create": "Vytvoriť",
    "search": "Hľadať",
    "loading": "Načítavam...",
    "back": "Späť",
    "next": "Ďalej",
    "yes": "Áno",
    "no": "Nie",
    "ok": "OK",
    "close": "Zatvoriť",
    "open": "Otvoriť",
    "name": "Meno",
    "email": "E-mail",
    "phone": "Telefón",
    "language": "Jazyk",
    "settings": "Nastavenia",
    "logout": "Odhlásiť sa",
    "today": "Dnes",
    "yesterday": "Včera",
    "thisMonth": "Tento mesiac",
    "lastMonth": "Minulý mesiac",
    "from": "Od",
    "to": "Do",
    "load": "Načítať",
    "ascending": "Vzostupne",
    "descending": "Zostupne",
    "all": "Všetky",
    "active": "Aktívne",
    "inactive": "Neaktívne",
    "saved": "Uložené",
    "error": "Chyba",
    "noData": "Žiadne dáta"
  },
  "sidebar": {
    "restaurantManagement": "Správa Reštaurácie",
    "dashboard": "Prehľad",
    "newOrder": "Nová objednávka",
    "preorders": "Predobjednávky",
    "kitchen": "Kuchyňa",
    "dispatch": "Rozvoz - nástenka",
    "restaurant": "Reštaurácia",
    "tableMap": "Mapovanie stolov",
    "kitchenManagement": "Správa Kuchyne",
    "categories": "Kategórie",
    "products": "Produkty",
    "lunchMenu": "Obedové menu",
    "kombo": "Kombo BOX",
    "pizza": "Pizza",
    "stockManagement": "Skladové hospodárstvo",
    "stock": "Skladové hospodárstvo",
    "recipes": "Recepty",
    "beverageStock": "Nápojový sklad",
    "analytics": "Analytika",
    "statistics": "Štatistiky",
    "summaries": "Sumáre",
    "companyManagement": "Správa firmy",
    "companyOverview": "Prehľad firmy",
    "suppliers": "Dodávatelia",
    "supplierComparison": "Porovnanie cien",
    "invoices": "Faktúry",
    "outgoingInvoices": "Vydané faktúry",
    "recurringInvoices": "Opakované faktúry",
    "reorderDrafts": "Návrhy objednávok",
    "banking": "Banka - auto-platby",
    "listsAndArchive": "Zoznamy & Archív",
    "fiskalReceipts": "Fiškálne doklady",
    "onlinePayments": "Platby online - archív",
    "deliveryManagement": "Správa rozvoz",
    "deliveryStats": "Rozvoz",
    "externalDriver": "Externý Šofér",
    "vehicleFleet": "Vozový Park",
    "tripLog": "Kniha jázd",
    "deliverySettings": "Nastavenia rozvozu",
    "marketing": "Marketing",
    "loyaltyProgram": "Vernostný program",
    "gifts": "Darčeky k objednávke",
    "coupons": "Kupóny a zľavy",
    "employees": "Zamestnanci",
    "permissions": "Oprávnenia rolí",
    "attendance": "Dochádzka",
    "revenueHandovers": "Odovzdanie tržby",
    "systemSettings": "Systémové nastavenia",
    "designSettings": "Design stránky",
    "openingHours": "Otváracie hodiny",
    "deliveryZones": "Oblasti doručenia",
    "fiskal": "Pokladňa - nastavenia",
    "fiskalClosures": "Pokladňa - uzávierky",
    "qrPayment": "QR Platba (SEPA)",
    "mobileApp": "Mobilná Aplikácia",
    "cms": "CMS Stránky",
    "general": "Všeobecné nastavenia",
    "integrations": "Prepojenie Wolt / Bolt",
    "smsSettings": "SMS nastavenia",
    "emailSettings": "E-mail nastavenia",
    "monitoring": "Monitoring & Alerty",
    "backups": "Zálohy databázy",
    "hikvision": "Hikvision zariadenia",
    "logs": "Logy",
    "franchises": "Pobočky (Super Admin)",
    "franchiseAdmins": "Admini pobočiek (Super Admin)"
  },
  "profile": {
    "title": "Môj profil",
    "subtitle": "Osobné údaje, bezpečnosť a dochádzka - všetko na jednom mieste",
    "tabs": {
      "personal": "Osobné údaje",
      "security": "Bezpečnosť",
      "performance": "Môj výkon",
      "attendance": "Moja dochádzka"
    },
    "firstName": "Meno",
    "lastName": "Priezvisko",
    "bio": "O mne",
    "preferredLanguage": "Jazyk rozhrania",
    "uploadAvatar": "Zmeniť profilový obrázok",
    "removeAvatar": "Odstrániť obrázok",
    "save": "Uložiť zmeny",
    "unsavedChanges": "Neuložené zmeny",
    "memberSince": "V tíme od {{date}}",
    "emailVerified": "E-mail overený",
    "emailNotVerified": "E-mail neoverený",
    "external": "Externý",
    "changePassword": "Zmena hesla",
    "currentPassword": "Aktuálne heslo",
    "newPassword": "Nové heslo (min. 6 znakov)",
    "confirmPassword": "Potvrdenie nového hesla",
    "logoutAll": "Odhlásiť všade",
    "lastActivity": "Posledná aktivita",
    "securityTips": "Tipy pre bezpečnosť"
  },
  "header": {
    "myProfile": "Môj profil",
    "myAttendance": "Moja dochádzka",
    "security": "Bezpečnosť",
    "logout": "Odhlásiť sa",
    "uzavierka": "Uzávierka",
    "notifications": "Notifikácie"
  },
  "attendance": {
    "title": "Moja dochádzka",
    "arrive": "Príchod",
    "leave": "Odchod",
    "notInShift": "Mimo zmeny",
    "inShift": "V zmene",
    "shiftClosed": "Zmena uzavretá",
    "haveANiceDay": "Pekný zvyšok dňa",
    "editTimes": "Upraviť časy zmeny",
    "totalWorked": "Odpracované",
    "workingDays": "Pracovných dní",
    "completedShifts": "Dokončené zmeny",
    "averagePerShift": "Priemer / zmena"
  },
  "ai": {
    "title": "AI preklad (Claude)",
    "description": "Automatický preklad názvov produktov, popisov a obsahu cez Claude API.",
    "apiKey": "Claude API kľúč",
    "apiKeyPlaceholder": "sk-ant-...",
    "apiKeyHelp": "Získaj na console.anthropic.com",
    "enableAuto": "Automatický preklad pri vytvorení/zmene produktov",
    "enabledLanguages": "Aktívne jazyky",
    "enabledLanguagesHelp": "Vyber jazyky pre tvoju lokalitu (susedov)",
    "test": "Otestovať",
    "testSuccess": "API kľúč funguje - preklad sa podarilo",
    "testFail": "Test zlyhal",
    "missingKey": "API kľúč nie je nastavený"
  }
}
